var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSupportMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 9.875C15.5 9.21196 15.2366 8.57607 14.7678 8.10723C14.2989 7.63839 13.663 7.375 13 7.375C12.337 7.375 11.7011 7.63839 11.2322 8.10723C10.7634 8.57607 10.5 9.21196 10.5 9.875V11.125C10.5 11.788 10.7634 12.4239 11.2322 12.8928C11.7011 13.3616 12.337 13.625 13 13.625C13.663 13.625 14.2989 13.3616 14.7678 12.8928C15.2366 12.4239 15.5 11.788 15.5 11.125M15.5 9.875V11.125M15.5 9.875V8C15.5 6.01088 14.7098 4.10322 13.3033 2.6967C11.8968 1.29018 9.98912 0.5 8 0.5C6.01088 0.5 4.10322 1.29018 2.6967 2.6967C1.29018 4.10322 0.5 6.01088 0.5 8V9.875M15.5 11.125V13.125C15.5 14.7819 14.1569 16.125 12.5 16.125H10.5M0.5 9.875C0.5 9.21196 0.763392 8.57607 1.23223 8.10723C1.70107 7.63839 2.33696 7.375 3 7.375C3.66304 7.375 4.29893 7.63839 4.76777 8.10723C5.23661 8.57607 5.5 9.21196 5.5 9.875V11.125C5.5 11.788 5.23661 12.4239 4.76777 12.8928C4.29893 13.3616 3.66304 13.625 3 13.625C2.33696 13.625 1.70107 13.3616 1.23223 12.8928C0.763392 12.4239 0.5 11.788 0.5 11.125V9.875Z",
    stroke: "#1A1D20",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.75,
    y: 14.25,
    width: 3.75,
    height: 3.125,
    rx: 1.5625,
    stroke: "#1A1D20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSupportMenu);
export default __webpack_public_path__ + "static/media/icon-support-menu.2e2e641a5c8a0cf701b1efdf51b6a2f7.svg";
export { ForwardRef as ReactComponent };